import blowingsnow from './blowingsnow.gif';
import clearnight from './clearnight.gif';
import clearwindynight from './clearwindynight.gif';
import cloudy from './cloudy.gif';
import cloudywindy from './cloudywindy.gif';
import drizzle from './drizzle.gif';
import dust from './dust.gif';
import flurries from './flurries.gif';
import fog from './fog.gif';
import fogdrizzle from './fogdrizzle.gif';
import hail from './hail.gif';
import hailrain from './hailrain.gif';
import haze from './haze.gif';
import heavyrain from './heavyrain.gif';
import heavysnow from './heavysnow.gif';
import icy from './icy.gif';
import moonshowernight from './moonshowernight.gif';
import moonsnownight from './moonsnownight.gif';
import moontstormnight from './moontstormnight.gif';
import mostlyclearnight from './mostlyclearnight.gif';
import mostlycloudyday from './mostlycloudyday.gif';
import mostlycloudynight from './mostlycloudynight.gif';
import mostlysunnyday from './mostlysunnyday.gif';
import na from './na.gif';
import partlycloudyday from './partlycloudyday.gif';
import partlycloudynight from './partlycloudynight.gif';
import partlycloudywindyday from './partlycloudywindyday.gif';
import partlycloudywindynight from './partlycloudywindynight.gif';
import rain from './rain.gif';
import rainsnow from './rainsnow.gif';
import rainwind from './rainwind.gif';
import sctdshowers from './sctdshowers.gif';
import showers from './showers.gif';
import smoke from './smoke.gif';
import snow from './snow.gif';
import snowice from './snowice.gif';
import snowshowers from './snowshowers.gif';
import snowthunder from './snowthunder.gif';
import sunnyday from './sunnyday.gif';
import sunnywindyday from './sunnywindyday.gif';
import sunrisesunset from './sunrisesunset.gif';
import sunshowerday from './sunshowerday.gif';
import sunsnowday from './sunsnowday.gif';
import suntstormday from './suntstormday.gif';
import tornado from './tornado.gif';
import tstorm from './tstorm.gif';
import windy from './windy.gif';

export const ANIMATED_ICON_PATH_MAP = {
  blowingsnow,
  clearnight,
  clearwindynight,
  cloudy,
  cloudywindy,
  drizzle,
  dust,
  flurries,
  fog,
  fogdrizzle,
  hail,
  hailrain,
  haze,
  heavyrain,
  heavysnow,
  icy,
  moonshowernight,
  moonsnownight,
  moontstormnight,
  mostlyclearnight,
  mostlycloudyday,
  mostlycloudynight,
  mostlysunnyday,
  na,
  partlycloudyday,
  partlycloudynight,
  partlycloudywindyday,
  partlycloudywindynight,
  rain,
  rainsnow,
  rainwind,
  sctdshowers,
  showers,
  smoke,
  snow,
  snowice,
  snowshowers,
  snowthunder,
  sunnyday,
  sunnywindyday,
  sunrisesunset,
  sunshowerday,
  sunsnowday,
  suntstormday,
  tornado,
  tstorm,
  windy,
};
